// extracted by mini-css-extract-plugin
export default {"documentArea":"styles_documentArea__stBO2","fileName":"styles_fileName__1vvMD","menuOverlay":"styles_menuOverlay__vx0Pf","icon":"styles_icon__YFmQt"};